import { SiteManagementDashboardContainer } from './organisms/SiteManagementDashboardContainer';

/**
 * Main Site Management Dashboard component
 * Now follows clean architecture: Component → Zustand Store pattern
 * All business logic extracted to stores and atomic components
 */
export function SiteManagementDashboard() {
  return <SiteManagementDashboardContainer />;
}
